import React from 'react';
import { seasonShortLabel } from '../../lib/playerFormatters';

export default function SeasonSelect({ seasons, value, onChange, label = 'Season' }) {
  const opts = seasons || [];
  return (
    <div className="flex items-center gap-2">
      <span className="i-mute text-xs uppercase tracking-wider">{label}</span>
      <div className="relative">
        <select
          className="i-search appearance-none pr-8"
          style={{ width: 'auto', minWidth: 150, padding: '8px 28px 8px 12px' }}
          value={value || ''}
          onChange={(e) => onChange(e.target.value)}
        >
          {!value && <option value="" disabled>Select season…</option>}
          {opts.map((s) => (
            <option key={s.seasonId} value={String(s.seasonId)}>
              {seasonShortLabel(s)}{s.isCurrent ? '  ●' : ''}
            </option>
          ))}
        </select>
        <span
          aria-hidden
          style={{
            position: 'absolute', right: 10, top: '50%', pointerEvents: 'none',
            width: 7, height: 7, borderBottom: '2px solid var(--intel-accent)',
            borderRight: '2px solid var(--intel-accent)', transform: 'translateY(-70%) rotate(45deg)',
          }}
        />
      </div>
    </div>
  );
}
